import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import Colors from "assets/Colors";
import { useTranslation } from "react-i18next";

function DocumentPDF({ data }) {
  const { t } = useTranslation();
  const { dateHeader, dataToPrint, currencyFormat } = data;
  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.body}>
        <View>
          <Text style={styles.date}>
            {t("containers.OperationsSales.OperationsSalesSummaryFor")}
            {dateHeader}
          </Text>
        </View>

        <View style={{ marginTop: 10 }}>
          <Text style={styles.title}>
            {t("containers.OperationsSales.OperationsSalesSummary")}
          </Text>

          <View
            style={[
              styles.row,
              styles.header,
              {
                fontSize: "8px",
                backgroundColor: "#f9f9f9",
              },
            ]}
          >
            <Text style={styles.row2}>
              {" "}
              {t("containers.OperationsSales.type")}
            </Text>
            <Text style={styles.row1}>
              {t("containers.OperationsSales.invoiceNumber")}
            </Text>
            <Text style={styles.row1}>
              {t("containers.OperationsSales.date")}
            </Text>
            <Text style={styles.row3}>
              {t("containers.OperationsSales.total")}
            </Text>
            <Text style={styles.row3}>
              {t("containers.OperationsSales.net")}
            </Text>
            <Text style={styles.row3}>
              {t("containers.OperationsSales.tax4")}
            </Text>
            <Text style={styles.row3}>
              {t("containers.OperationsSales.tax4Base")}
            </Text>

            <Text style={styles.row3}>
              {t("containers.OperationsSales.tax10")}
            </Text>
            <Text style={styles.row3}>
              {t("containers.OperationsSales.tax10Base")}
            </Text>

            <Text style={styles.row3}>
              {t("containers.OperationsSales.tax21")}
            </Text>
            <Text style={styles.row3}>
              {t("containers.OperationsSales.tax21Base")}
            </Text>
            <Text style={styles.row1}>
              {t("containers.OperationsSales.employee")}
            </Text>
            <Text style={styles.row1}>
              {t("containers.OperationsSales.chargedBy")}
            </Text>
            <Text style={styles.row1}>
              {t("containers.OperationsSales.customer")}
            </Text>
            <Text style={styles.row1}>
              {t("containers.OperationsSales.address")}
            </Text>
            <Text style={styles.row2}>
              {t("containers.OperationsSales.CommissionedTo")}
            </Text>
            <Text style={styles.row2}>
              {t("containers.OperationsSales.paymentMethod")}
            </Text>
          </View>
          {dataToPrint.map((row, i) => (
            // const values = Object.values(row);
            <View key={i} style={styles.row} wrap={false}>
              <Text style={styles.row2}>{row[0]}</Text>
              <Text style={styles.row1}>{row[1]}</Text>
              <Text style={styles.row1}>{row[2]}</Text>
              <Text style={styles.row3}>{currencyFormat(row[3])}</Text>
              <Text style={styles.row3}>{currencyFormat(row[4])}</Text>
              <Text style={styles.row3}>{currencyFormat(row[5])}</Text>
              <Text style={styles.row3}>{currencyFormat(row[6])}</Text>
              <Text style={styles.row3}>{currencyFormat(row[7])}</Text>
              <Text style={styles.row3}>{currencyFormat(row[8])}</Text>
              <Text style={styles.row3}>{currencyFormat(row[9])}</Text>
              <Text style={styles.row3}>{currencyFormat(row[10])}</Text>
              <Text style={styles.row1}>{row[11]}</Text>
              <Text style={styles.row1}>{row[12]}</Text>
              <Text style={styles.row1}>{row[13]}</Text>
              <Text style={styles.row1}>{row[14]}</Text>
              <Text style={styles.row2}>{row[15]}</Text>
              <Text style={styles.row2}>{row[16]}</Text>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
}

const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 20,
  },
  itemContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  divider: {
    borderBottomWidth: 0.5,
    borderBottomColor: Colors.background_dividers,
    marginBottom: 15,
  },
  date: {
    fontSize: 7,
    fontWeight: 300,
    marginTop: -20,
    marginBottom: 20,
    textAlign: "right",
  },
  title: {
    fontSize: 7,
    fontWeight: 500,
    marginBottom: 5,
    paddingHorizontal: 10,
  },
  textIfo: {
    fontSize: 7,
    fontWeight: 300,
    marginBottom: 10,
  },
  textIfoName: {
    fontSize: 7,
    fontWeight: 300,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "100%",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    borderTop: "1px solid #EEE",
    paddingTop: 8,
    paddingBottom: 8,
    marginHorizontal: 10,
  },
  row1: {
    width: "9%",
    fontSize: 7,
    marginLeft: 5,
  },
  row2: {
    width: "4%",
    fontSize: 7,
    marginLeft: 5,
  },
  row3: {
    width: "5%",
    fontSize: 7,
    marginLeft: 5,
  },
  row4: {
    width: "20%",
    fontSize: 7,
    marginLeft: 5,
  },
  row5: {
    width: "15%",
    fontSize: 7,
    marginLeft: 5,
    textAlign: "right",
  },
  row6: {
    width: "10%",
    fontSize: 7,
    marginLeft: 5,
    textAlign: "right",
  },
  row7: {
    width: "10%",
    fontSize: 7,
    marginLeft: 5,
    textAlign: "right",
  },
  containerItems: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  containerPrices: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "70%",
  },
  mapItems: {
    width: "100%",
  },
  items: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
});
export default DocumentPDF;
